<template>
  <div style="padding: 15px 0 0 8px">
    <!-- <el-select
      v-model="simulationType"
      @change="simulationTypeChange"
      size="mini"
      style="width: 130px; margin-bottom: 8px"
    >
      <el-option :key="2" label="交通模拟" :value="2"> </el-option>
      <el-option :key="3" label="车辆同时出现测试" :value="3"> </el-option>
    </el-select> -->
    <!-- 漫游路径 -->
    <div v-if="type == 1">
      <el-row>
        <el-col :span="24">
          <el-button
            type="primary"
            @click="mapSelectDots"
            size="medium"
            class="but"
            >地图选点</el-button
          >
          <el-button type="success" @click="savePath" size="medium" class="but"
            >保存路线</el-button
          >
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <el-button
            type="primary"
            @click="playPathFun"
            v-if="this.savePaths.length"
            plain
            size="small"
            class="but"
            >播放</el-button
          >
          <el-button
            type="primary"
            @click="suspendFun"
            v-if="suspend && driveShow"
            plain
            size="small"
            class="but"
            >暂停</el-button
          >
          <el-button
            type="primary"
            @click="continueFun"
            v-if="!suspend && driveShow"
            plain
            size="small"
            class="but"
            >继续</el-button
          >
          <el-button
            type="primary"
            @click="reset"
            size="small"
            plain
            class="but"
            >重置</el-button
          >
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <el-button
            type="primary"
            @click="addVehicle"
            v-if="this.savePaths.length"
            plain
            size="small"
            class="but"
            >增加车辆</el-button
          >
        </el-col>
      </el-row>
    </div>
    <!-- 模拟 -->
    <div v-if="type == 2">
      <el-row>
        <el-col :span="24">
          <el-input-number
            v-model="vehicleSum"
            size="small"
            @change="handleChange"
            :min="1"
          ></el-input-number>
          <span style="margin-left: 10px; color: aliceblue; font-size: 14px"
            >车辆总数</span
          >
        </el-col>
      </el-row>
      <el-row style="margin-top: 8px">
        <el-col :span="24">
          <el-select
            v-model="carVelocity"
            @change="velocityChange"
            size="small"
            style="width: 130px"
            placeholder="请选择车辆速度"
          >
            <el-option :key="1" label="快速" :value="1"> </el-option>
            <el-option :key="4" label="中等" :value="4"> </el-option>
            <el-option :key="6" label="慢速" :value="6"> </el-option>
          </el-select>
          <!-- <el-input-number
            v-model="carVelocity"
            size="small"
            @change="velocityChange"
            :min="1"
          ></el-input-number> -->
          <span style="margin-left: 10px; color: aliceblue; font-size: 14px"
            >车辆速度</span
          >
        </el-col>
      </el-row>

      <el-row style="margin-top: 8px">
        <el-col :span="24">
          <el-select
            v-model="intervalDate"
            @change="intervalDateChange"
            size="small"
            style="width: 130px"
            placeholder="请选择车辆出现间隔时间"
          >
            <el-option :key="2" label="短" :value="2"> </el-option>
            <el-option :key="4" label="中等" :value="4"> </el-option>
            <el-option :key="6" label="长" :value="6"> </el-option>
            <el-option :key="0" label="同时出现在起点" :value="0"> </el-option>
          </el-select>
          <!-- <el-input-number
            v-model="intervalDate"
            size="small"
            @change="intervalDateChange"
            :min="1"
          ></el-input-number> -->
          <span style="margin-left: 10px; color: aliceblue; font-size: 14px"
            >车辆出现间隔时间</span
          >
        </el-col>
      </el-row>

      <el-row style="margin-top: 8px">
        <el-col :span="24">
          <el-button
            type="primary"
            @click="CZMLmapSelectDots"
            size="medium"
            class="but"
            >地图选点</el-button
          >
          <el-button
            type="success"
            @click="CZMLSavePath"
            size="medium"
            class="but"
            >保存路线</el-button
          >
        </el-col>
      </el-row>
      <el-row style="margin-top: 8px">
        <el-col :span="24">
          <el-button
            type="primary"
            @click="addPath(1)"
            size="medium"
            class="but"
            >添加一条路径文件</el-button
          >
        </el-col>
      </el-row>
      <el-row style="margin-top: 8px">
        <el-col :span="24">
          <el-button
            type="primary"
            @click="addPath(2)"
            size="medium"
            class="but"
            >添加二条路径文件</el-button
          >
          <el-button
            type="primary"
            @click="initializePlace"
            size="medium"
            class="but"
            >初始化位置</el-button
          >
        </el-col>
      </el-row>

      <!-- <el-row>
        <el-col :span="24">
          <el-button
            type="primary"
            @click="CZMLmapSelectDots"
            size="medium"
            class="but"
            >地图选点</el-button
          >
          
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="24">
          <el-button
            type="primary"
            @click="CZMLFun"
            size="medium"
            class="but"
            style="margin-top: 8px"
            >开始</el-button
          >
          <el-button
            type="primary"
            @click="CZMLSuspendFun"
            size="medium"
            class="but"
            style="margin-top: 8px"
          >
            {{ suspend ? "继续" : "暂停" }}
          </el-button>
          <!-- <el-button
            type="primary"
            @click="CZMLaaa"
            size="medium"
            class="but"
            style="margin-top: 10px"
            >读取</el-button
          > -->
          <el-button
            type="danger"
            @click="resetCZML"
            size="medium"
            class="but"
            style="margin-top: 8px"
            >重置</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24"> </el-col>
      </el-row>
    </div>
    <!-- 测试 -->
    <div v-if="type == 3">
      <el-row>
        <el-col :span="24">
          <el-input-number
            v-model="vehicleSum"
            size="small"
            @change="testCZMLHandleChange"
            :min="1"
          ></el-input-number>
          <span style="margin-left: 10px; color: aliceblue; font-size: 14px"
            >车辆总数</span
          >
        </el-col>
      </el-row>
      <el-row style="margin-top: 8px">
        <el-col :span="24">
          <el-select
            v-model="carVelocity"
            @change="testCZMLVelocityChange"
            size="small"
            style="width: 130px"
            placeholder="请选择车辆速度"
          >
            <el-option :key="1" label="快速" :value="1"> </el-option>
            <el-option :key="4" label="中等" :value="4"> </el-option>
            <el-option :key="6" label="慢速" :value="6"> </el-option>
          </el-select>
          <span style="margin-left: 10px; color: aliceblue; font-size: 14px"
            >车辆速度</span
          >
        </el-col>
      </el-row>

      <el-row style="margin-top: 8px">
        <el-col :span="24">
          <el-select
            v-model="intervalDate"
            @change="testCZMLIntervalDateChange"
            size="small"
            style="width: 130px"
            placeholder="请选择车辆出现间隔时间"
          >
            <el-option :key="2" label="短" :value="2"> </el-option>
            <el-option :key="4" label="中等" :value="4"> </el-option>
            <el-option :key="6" label="长" :value="6"> </el-option>
          </el-select>
          <span style="margin-left: 10px; color: aliceblue; font-size: 14px"
            >车辆出现间隔时间</span
          >
        </el-col>
      </el-row>

      <el-row style="margin-top: 8px">
        <el-col :span="24">
          <el-button
            type="primary"
            @click="testCZMLmapSelectDots"
            size="medium"
            class="but"
            >地图选点</el-button
          >
          <el-button
            type="success"
            @click="testCZMLSavePath"
            size="medium"
            class="but"
            >保存路线</el-button
          >
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-button
            type="primary"
            @click="testCZMLFun"
            size="medium"
            class="but"
            style="margin-top: 8px"
            >开始</el-button
          >
          <el-button
            type="primary"
            @click="testCZMLSuspendFun"
            size="medium"
            class="but"
            style="margin-top: 8px"
          >
            {{ suspend ? "继续" : "暂停" }}
          </el-button>
          <el-button
            type="danger"
            @click="testResetCZML"
            size="medium"
            class="but"
            style="margin-top: 8px"
            >重置</el-button
          >
        </el-col>
      </el-row>

      <el-row style="margin-top: 8px">
        <el-col :span="24">
          <el-button
            type="primary"
            @click="initializePlace"
            size="medium"
            class="but"
            >初始化位置</el-button
          >
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24"> </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import * as mapWork from "./map";
import * as CzmlLayerWork from "./CzmlLayer";
import * as testCZML from "./testCZML";

export default {
  data() {
    return {
      type: 2,
      savePaths: mapWork.savePaths,
      fixedRoute: null,
      suspend: false,
      driveShow: false,
      vehicleSum: 10,
      carVelocity: 4,
      intervalDate: 2,
      simulationType: 2,
    };
  },
  computed: {},
  watch: {},
  created() {
    console.log(5555);
  },
  mounted() {
    this.init();
    console.log(Cesium, "CesiumCesium");
  },
  methods: {
    init() {
      this.driveShow = false;
      this.initialTime = 0;
    },
    mapSelectDots() {
      mapWork.setPoint();
    },

    CZMLmapSelectDots() {
      CzmlLayerWork.setPoint();
    },
    savePath() {
      mapWork.savePath();
    },

    CZMLSavePath() {
      CzmlLayerWork.savePath();
    },
    continueFun() {
      //继续
      mapWork.continueFun();
      this.suspend = true;
    },
    suspendFun() {
      //暂停
      this.suspend = false;
      mapWork.suspendFun();
    },
    playPathFun() {
      if (this.savePaths.length) {
        this.suspend = true;
        this.driveShow = true;
        this.drive();
      } else {
        this.$message({
          message: "请先保存路线",
          type: "warning",
        });
      }
    },
    drive() {
      mapWork.drive();
    },
    addVehicle() {
      this.drive();
    },
    reset() {
      mapWork.reset();
    },
    CZMLFun() {
      CzmlLayerWork.showAircraft();
    },
    CZMLSuspendFun() {
      this.suspend = !this.suspend;
      CzmlLayerWork.suspend();
    },
    CZMLaaa() {
      CzmlLayerWork.internationalizationDate();
    },
    resetCZML() {
      this.vehicleSum = 10;
      this.carVelocity = 4;
      this.intervalDate = 2;
      this.suspend = false;
      CzmlLayerWork.reset();
      CzmlLayerWork.suspend();
    },
    initializePlace() {
      this.$GLOBAL.map.centerAt({
        y: 22.55570388473932,
        x: 113.93440364212167,
        alt: 300,
        heading: 50,
        pitch: -49,
      });
      // this.$GLOBAL.map.setCameraView({
      //   lat: 40.893923,
      //   lng: 121.917192,
      //   alt: 691,
      //   heading: 64,
      //   pitch: -46,
      // });
    },
    handleChange(num) {
      CzmlLayerWork.setVehicleSum(num);
    },
    velocityChange(num) {
      CzmlLayerWork.setCarVelocity(num);
    },
    intervalDateChange(num) {
      CzmlLayerWork.setIntervalDate(num);
    },
    addPath(num) {
      if (num == 2) {
        CzmlLayerWork.pathDataFun();
        setTimeout((res) => {
          CzmlLayerWork.pathDataFun2();
        }, 1500);
      } else {
        CzmlLayerWork.pathDataFun();
      }
      setTimeout((res) => {
        this.$message({
          showClose: true,
          message: "添加成功",
          type: "success",
        });
      }, 500);
    },
    simulationTypeChange(type) {
      this.type = type;
    },
    // 测试用
    testCZMLHandleChange(num) {
      testCZML.setVehicleSum(num);
    },
    testCZMLVelocityChange(num) {
      testCZML.setCarVelocity(num);
    },
    testCZMLIntervalDateChange(num) {
      testCZML.setIntervalDate(num);
    },
    testCZMLmapSelectDots() {
      testCZML.setPoint();
    },
    testCZMLSavePath() {
      testCZML.savePath();
    },
    testCZMLFun() {
      testCZML.showAircraft();
    },
    testCZMLSuspendFun() {
      this.suspend = !this.suspend;
      testCZML.suspend();
    },
    testResetCZML() {
      this.vehicleSum = 10;
      this.carVelocity = 4;
      this.intervalDate = 2;
      testCZML.reset();
    },
  },
  destroyed() {
    mapWork.init();
  },
};
</script>

<style></style>
